import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import AppParser from './AppParser';
function AppContextSidebar(props) {
    const { children } = props;
    return _jsx(AppParser, { children: children });
}
export default AppContextSidebar;
